import { axiosGet } from '@/api/handlers';
import { useMutation, useQuery } from '@/api/hooks';
import type { z } from 'zod';
import {
  type RelatedMaterialFormSchema,
  type RelatedMaterialModel,
  type RelatedMaterialMutationParamsSchema,
  RelatedMaterialsModel,
} from '../projects/_models/related-material';
import { queryKeyMap } from '../review-sheet/utils/query-keys';

export const useRelatedMaterials = (projectId: string) => {
  return useQuery({
    queryKey: queryKeyMap.relatedMaterials(projectId),
    queryFn: async () => {
      const res = await axiosGet(
        `/api/projects/${projectId}/related-materials/`,
      );

      return RelatedMaterialsModel.parse(res);
    },
    enabled: !!projectId,
  });
};

const _useCreateRelatedMaterial = () => {
  return useMutation({
    mutationFn: async (
      _: z.infer<typeof RelatedMaterialFormSchema> & {
        attachmentIds: z.infer<
          typeof RelatedMaterialMutationParamsSchema
        >['attachmentIds'];
      },
    ) => {
      // const { projectId, ...restValues } = values;
      // const params = RelatedMaterialMutationParamsSchema.parse({
      //   ...restValues,
      // });
      // const res = await axiosPost(
      //   `/api/projects/${projectId}/related-materials/`,
      //   params,
      // );
      // await invalidate(queryKeyMap.relatedMaterials(projectId));
      // return RelatedMaterialModel.parse(res);
    },
  });
};

const _useUpdateRelatedMaterial = () => {
  return useMutation({
    mutationFn: async (
      _: z.infer<typeof RelatedMaterialFormSchema> & {
        id: z.infer<typeof RelatedMaterialModel.shape.id>;
        attachmentIds: z.infer<
          typeof RelatedMaterialMutationParamsSchema
        >['attachmentIds'];
      },
    ) => {
      // const { projectId, id, ...restValues } = values;
      // const params = RelatedMaterialMutationParamsSchema.parse({
      //   ...restValues,
      // });
      // const res = await axiosPut(
      //   `/api/projects/${projectId}/related-materials/${id}/`,
      //   params,
      // );
      // await invalidate(queryKeyMap.relatedMaterials(projectId));
      // return RelatedMaterialModel.parse(res);
    },
  });
};
